import { createSlice } from '@reduxjs/toolkit';
import { addOrRemoveSelectedChannel, getChannels } from '../thunks/channelThunk';
import { toast } from 'react-toastify';

const initialState = {
    isLoading: true,
    error: null,
    selectedChannel: [],
    availablechannels: [],
    isChannelSelected: 0
};

const channelSlice = createSlice({
    name: 'channel',
    initialState,
    reducers: {
        handleChannelChange(state, action) {
            return { ...state, selectedChannel: action.payload.selected };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChannels.fulfilled, (state,action) => {
                state.availablechannels = getChannelAndPartnersData(action.payload?.channels);
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getChannels.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getChannels.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(addOrRemoveSelectedChannel.fulfilled, (state,action) => {
                if(action.payload?.status_code === 200){
                    state.error = null;
                    state.isLoading = false;
                    state.isChannelSelected+= 1;
                    state.selectedChannel = [];
                    toast.success('Selected channel updated successfully');
                } else{
                    state.isLoading = false;
                    toast.error('Please retry!');
                }
            
            })
            .addCase(addOrRemoveSelectedChannel.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(addOrRemoveSelectedChannel.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

const getChannelAndPartnersData = (data) => {
    if (data?.length > 0) {
        return data.map(item => ({
            value: item.id,
            label: item.name
        }));
    }
    return [];
};

export const { actions } = channelSlice;
export default channelSlice.reducer;
